import { StyleSheet, Text, View } from 'react-native';
import { landingPageContent } from '../../../constants/Content';
import { COLORS } from '../../../styles/colors';
import { fontFamilies } from '../../../utils/fontLoader';
import BodyText from '../../ui/BodyText';
import Heading from '../../ui/Heading';

const { mainHeadline, steps } = landingPageContent.howItWorksSection;

const HowItWorksMobile = () => {
  return (
    <View style={styles.sectionContainer}>
      <Heading level="h2" style={styles.mainHeadline} accessibilityRole="header" aria-level="2">
        {mainHeadline}
      </Heading>
      <View style={styles.stepsContainer}>
        {steps.map((step, index) => (
          <View key={index} style={styles.stepCard} accessibilityRole="listitem">
            <Text style={styles.stepTitle} accessibilityRole="header" aria-level="3">
              {step.title}
            </Text>
            <BodyText style={styles.stepDescription} accessibilityRole="text">
              {step.description}
            </BodyText>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  sectionContainer: {
    backgroundColor: COLORS.darkSection,
    paddingVertical: 80,
    paddingHorizontal: 24,
  },
  mainHeadline: {
    color: COLORS.white,
    textAlign: 'center',
    marginBottom: 48,
    fontSize: 32,
    lineHeight: 40,
  },
  stepsContainer: {
    width: '100%',
  },
  stepCard: {
    backgroundColor: '#1C1C1E',
    borderRadius: 20,
    padding: 24,
    marginBottom: 16,
  },
  stepTitle: {
    fontFamily: fontFamilies.satoshi.bold,
    fontSize: 20,
    color: COLORS.white,
    marginBottom: 8,
  },
  stepDescription: {
    fontFamily: fontFamilies.satoshi.regular,
    fontSize: 16,
    color: 'rgba(255, 255, 255, 0.8)',
    lineHeight: 24,
  },
});

export default HowItWorksMobile;
